export default __webpack_public_path__ + "static/media/rafaela.be0a5346.png";